<template>
    <div class="hero-non-logged -wrap" v-if="!isLoggedIn">
        <TotemIntro :type="$totemLang === 'dk' ? 'video' : 'image'" v-on:on-play-video="openVideoModal()">
            <template #title>
                <span v-html="$t('Hero.non_logged_title_' + $totemLang)"></span>
            </template>
            <template #description>
                <span v-html="$t('Hero.non_logged_description_' + $totemLang)"></span>
            </template>
            <template #buttons>
                <TotemRouterLink color="primary" :to="router.buttonLink" :label="$t('Hero_non_logged_button_' + $totemLang)" />
                <TotemRouterLink color="secondary" :to="router.secondaryButtonLink" :label="$t('Hero_non_logged_button_secondary_' + $totemLang)" v-if="$totemLang !== 'no'"/>
                <TotemButton color="secondary" @click="openCta" :label="$t('Hero_non_logged_button_secondary_' + $totemLang)" v-if="$totemLang === 'no'" />
            </template>
            <template #image>
                <div class="intro__image-box">
                    <img :src="require('@/assets/images/hero/hero-image-non-logged' + '-' + $totemLang +'.png')" alt="" class="intro__image"/>
                </div>
            </template>
            <template #video>
                <img :src="require('@/assets/images/hero/video-screen-non-logged-' + $totemLang + '.png')" alt="" class="intro__video-thumbnail" @click="openVideoModal"/>
            </template>
        </TotemIntro>
        <HeroVideoModal :videoSrc="videoSrc" />
    </div>
</template>

<script>
    import { getTrialFormRoute } from '@/routes'
    import HeroVideoModal from '@/components/landingpage/hero/HeroVideoModal'
    import { mapGetters } from 'vuex'

    export default {
        name: 'hero-non-logged',
        components: {
            HeroVideoModal
        },
        data () {
            return {
                trialFormRoute: getTrialFormRoute()
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            videoSrc () {
                switch (this.$totemLang) {
                case 'dk':
                    return 'https://player.vimeo.com/video/412102747?h=fe66b84773'
                }
                return ''
            },
            router () {
                switch (this.$totemLang) {
                case 'fi':
                    return {
                        buttonLink: { name: 'login' },
                        secondaryButtonLink: this.trialFormRoute
                    }
                case 'se':
                    return {
                        buttonLink: { name: 'login' },
                        secondaryButtonLink: this.trialFormRoute
                    }
                case 'no':
                    return {
                        buttonLink: {  name: 'all-content', params: { packageSlug: 'no-ki' } },
                        secondaryButtonLink: {}
                    }
                case 'dk':
                    return {
                        buttonLink: { name: 'all-packages-all-content', label: this.$t('HeroGoLearn.see_all_courses') },
                        secondaryButtonLink: this.trialFormRoute
                    }
                }
            }
        },
        methods: {
            goTo (params) {
                this.$router.push(params)
            },
            openVideoModal () {
                this.$modal.show('hero-video-modal')
            },
            openCta () {
                window.open('https://www.eduhouse.no/om-oss/kontakt-oss', '_blank')
            },
        }
    }
</script>

<style lang="scss">
    .hero-non-logged {
        &.-wrap {
            [class*="mobile"] & {
                padding: 30px 20px;
            }
        }
    }
</style>
